export default __webpack_public_path__ + "25a5106e0cd1073dc05e4a7df1ce4fba.png";